import dynamic from "next/dynamic";

export const CaseStudiesCarousel = dynamic(() => import("./component"));
